const recipientEmail = (state = "", action) => {
    switch(action.type) {
        case 'recipientEmail':
            return action.payload;
        default:
            return state;
    }
}

export default recipientEmail;